/**
 * Nuluyafit — Traduction gratuite de la page 17TRACK
 *
 * Langues :
 * - Anglais : /apps/17TRACK
 * - Français : /fr/apps/17TRACK
 * - Espagnol : /es/apps/17TRACK
 * - Allemand : /de/apps/17TRACK
 *
 * Ce script ne modifie pas le fonctionnement du formulaire.
 * Il remplace uniquement les textes visibles et attributs accessibles.
 */

(() => {
  'use strict';

  const pathname = window.location.pathname.toLowerCase();

  if (!pathname.includes('/apps/17track')) {
    return;
  }

  /**
   * Détection de la langue Shopify depuis l’URL.
   * L’anglais reste la langue par défaut.
   */
  const getLanguage = () => {
    if (pathname === '/fr/apps/17track' || pathname.startsWith('/fr/apps/17track/')) {
      return 'fr';
    }

    if (pathname === '/es/apps/17track' || pathname.startsWith('/es/apps/17track/')) {
      return 'es';
    }

    if (pathname === '/de/apps/17track' || pathname.startsWith('/de/apps/17track/')) {
      return 'de';
    }

    return 'en';
  };

  const language = getLanguage();

  const translations = {
    en: {
      title: 'Track your order',
      orderTab: 'Order number',
      trackingTab: 'Tracking number',
      orderPlaceholder: 'Order number',
      trackingPlaceholder: 'Tracking number',
      emailPlaceholder: 'Email',
      trackButton: 'TRACK',
      loading: 'Tracking...',

      errors: {
        orderRequired: 'Please enter your order number.',
        trackingRequired: 'Please enter your tracking number.',
        emailRequired: 'Please enter your email address.',
        emailInvalid: 'Please enter a valid email address.'
      },

      exactText: {
        'Suivre votre commande': 'Track your order',
        'Numéro de commande': 'Order number',
        'Numéro de suivi': 'Tracking number',
        'E-mail': 'Email',
        'SUIVRE': 'TRACK',
        'Suivi...': 'Tracking...',
        'Veuillez saisir le numéro de commande.':
          'Please enter your order number.',
        'Veuillez saisir le numéro de suivi.':
          'Please enter your tracking number.',
        'Veuillez saisir votre adresse e-mail.':
          'Please enter your email address.',
        'Veuillez saisir une adresse e-mail valide.':
          'Please enter a valid email address.',

        'Seguir tu pedido': 'Track your order',
        'Número de pedido': 'Order number',
        'Número de seguimiento': 'Tracking number',
        'Correo electrónico': 'Email',
        'SEGUIR': 'TRACK',
        'Rastreando...': 'Tracking...',

        'Bestellung verfolgen': 'Track your order',
        'Bestellnummer': 'Order number',
        'Sendungsnummer': 'Tracking number',
        'E-Mail': 'Email',
        'VERFOLGEN': 'TRACK',
        'Wird verfolgt...': 'Tracking...'
      }
    },

    fr: {
      title: 'Suivre votre commande',
      orderTab: 'Numéro de commande',
      trackingTab: 'Numéro de suivi',
      orderPlaceholder: 'Numéro de commande',
      trackingPlaceholder: 'Numéro de suivi',
      emailPlaceholder: 'Adresse e-mail',
      trackButton: 'SUIVRE',
      loading: 'Suivi en cours...',

      errors: {
        orderRequired: 'Veuillez saisir votre numéro de commande.',
        trackingRequired: 'Veuillez saisir votre numéro de suivi.',
        emailRequired: 'Veuillez saisir votre adresse e-mail.',
        emailInvalid: 'Veuillez saisir une adresse e-mail valide.'
      },

      exactText: {
        'Track your order': 'Suivre votre commande',
        'Order number': 'Numéro de commande',
        'Tracking number': 'Numéro de suivi',
        'Email': 'Adresse e-mail',
        'TRACK': 'SUIVRE',
        'Tracking...': 'Suivi en cours...',
        'Please enter your order number.':
          'Veuillez saisir votre numéro de commande.',
        'Please enter your tracking number.':
          'Veuillez saisir votre numéro de suivi.',
        'Please enter your email address.':
          'Veuillez saisir votre adresse e-mail.',
        'Please enter a valid email address.':
          'Veuillez saisir une adresse e-mail valide.',

        'Número de pedido': 'Numéro de commande',
        'Número de seguimiento': 'Numéro de suivi',
        'Correo electrónico': 'Adresse e-mail',
        'SEGUIR': 'SUIVRE',

        'Bestellnummer': 'Numéro de commande',
        'Sendungsnummer': 'Numéro de suivi',
        'E-Mail': 'Adresse e-mail',
        'VERFOLGEN': 'SUIVRE'
      }
    },

    es: {
      title: 'Seguir tu pedido',
      orderTab: 'Número de pedido',
      trackingTab: 'Número de seguimiento',
      orderPlaceholder: 'Número de pedido',
      trackingPlaceholder: 'Número de seguimiento',
      emailPlaceholder: 'Correo electrónico',
      trackButton: 'SEGUIR',
      loading: 'Buscando seguimiento...',

      errors: {
        orderRequired: 'Introduce tu número de pedido.',
        trackingRequired: 'Introduce tu número de seguimiento.',
        emailRequired: 'Introduce tu correo electrónico.',
        emailInvalid: 'Introduce una dirección de correo electrónico válida.'
      },

      exactText: {
        'Track your order': 'Seguir tu pedido',
        'Order number': 'Número de pedido',
        'Tracking number': 'Número de seguimiento',
        'Email': 'Correo electrónico',
        'TRACK': 'SEGUIR',
        'Tracking...': 'Buscando seguimiento...',
        'Please enter your order number.':
          'Introduce tu número de pedido.',
        'Please enter your tracking number.':
          'Introduce tu número de seguimiento.',
        'Please enter your email address.':
          'Introduce tu correo electrónico.',
        'Please enter a valid email address.':
          'Introduce una dirección de correo electrónico válida.',

        'Suivre votre commande': 'Seguir tu pedido',
        'Numéro de commande': 'Número de pedido',
        'Numéro de suivi': 'Número de seguimiento',
        'Adresse e-mail': 'Correo electrónico',
        'E-mail': 'Correo electrónico',
        'SUIVRE': 'SEGUIR',
        'Suivi...': 'Buscando seguimiento...',
        'Suivi en cours...': 'Buscando seguimiento...',

        'Bestellnummer': 'Número de pedido',
        'Sendungsnummer': 'Número de seguimiento',
        'E-Mail': 'Correo electrónico',
        'VERFOLGEN': 'SEGUIR'
      }
    },

    de: {
      title: 'Bestellung verfolgen',
      orderTab: 'Bestellnummer',
      trackingTab: 'Sendungsnummer',
      orderPlaceholder: 'Bestellnummer',
      trackingPlaceholder: 'Sendungsnummer',
      emailPlaceholder: 'E-Mail-Adresse',
      trackButton: 'VERFOLGEN',
      loading: 'Sendung wird gesucht...',

      errors: {
        orderRequired: 'Bitte gib deine Bestellnummer ein.',
        trackingRequired: 'Bitte gib deine Sendungsnummer ein.',
        emailRequired: 'Bitte gib deine E-Mail-Adresse ein.',
        emailInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein.'
      },

      exactText: {
        'Track your order': 'Bestellung verfolgen',
        'Order number': 'Bestellnummer',
        'Tracking number': 'Sendungsnummer',
        'Email': 'E-Mail-Adresse',
        'TRACK': 'VERFOLGEN',
        'Tracking...': 'Sendung wird gesucht...',
        'Please enter your order number.':
          'Bitte gib deine Bestellnummer ein.',
        'Please enter your tracking number.':
          'Bitte gib deine Sendungsnummer ein.',
        'Please enter your email address.':
          'Bitte gib deine E-Mail-Adresse ein.',
        'Please enter a valid email address.':
          'Bitte gib eine gültige E-Mail-Adresse ein.',

        'Suivre votre commande': 'Bestellung verfolgen',
        'Numéro de commande': 'Bestellnummer',
        'Numéro de suivi': 'Sendungsnummer',
        'Adresse e-mail': 'E-Mail-Adresse',
        'E-mail': 'E-Mail-Adresse',
        'SUIVRE': 'VERFOLGEN',
        'Suivi...': 'Sendung wird gesucht...',
        'Suivi en cours...': 'Sendung wird gesucht...',

        'Número de pedido': 'Bestellnummer',
        'Número de seguimiento': 'Sendungsnummer',
        'Correo electrónico': 'E-Mail-Adresse',
        'SEGUIR': 'VERFOLGEN'
      }
    }
  };

  const dictionary = translations[language] || translations.en;

  /**
   * Modifie le texte d’un élément précis.
   */
  const setText = (selector, text) => {
    const element = document.querySelector(selector);

    if (element && element.textContent.trim() !== text) {
      element.textContent = text;
    }
  };

  /**
   * Modifie le placeholder et l’aria-label d’un champ.
   */
  const setInputTranslation = (selector, text) => {
    const input = document.querySelector(selector);

    if (!input) {
      return;
    }

    if (input.getAttribute('placeholder') !== text) {
      input.setAttribute('placeholder', text);
    }

    if (input.getAttribute('aria-label') !== text) {
      input.setAttribute('aria-label', text);
    }
  };

  /**
   * Remplace les textes exacts générés dynamiquement par 17TRACK.
   */
  const translateTextNodes = (root) => {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.parentElement;

          if (!parent) {
            return NodeFilter.FILTER_REJECT;
          }

          if (
            parent.closest('script, style, noscript, textarea') ||
            parent.closest('a[href*="17track.net"]')
          ) {
            return NodeFilter.FILTER_REJECT;
          }

          return node.nodeValue.trim()
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    const nodes = [];

    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach((node) => {
      const originalText = node.nodeValue.trim();
      const translatedText = dictionary.exactText[originalText];

      if (!translatedText || originalText === translatedText) {
        return;
      }

      const leadingSpaces = node.nodeValue.match(/^\s*/)?.[0] || '';
      const trailingSpaces = node.nodeValue.match(/\s*$/)?.[0] || '';

      node.nodeValue =
        leadingSpaces + translatedText + trailingSpaces;
    });
  };

  /**
   * Traduit les messages d’erreur selon le champ concerné.
   */
  const translateValidationErrors = () => {
    const orderError = document.querySelector(
      '#orderForm_order_no_help .ant-form-item-explain-error'
    );

    if (orderError) {
      orderError.textContent = dictionary.errors.orderRequired;
    }

    const trackingError = document.querySelector(
      '#trackingForm_track_no_help .ant-form-item-explain-error'
    );

    if (trackingError) {
      trackingError.textContent = dictionary.errors.trackingRequired;
    }

    const emailError = document.querySelector(
      '#orderForm_user_email_help .ant-form-item-explain-error'
    );

    if (emailError) {
      const currentText = emailError.textContent.toLowerCase();

      const seemsInvalid =
        currentText.includes('valid') ||
        currentText.includes('valide') ||
        currentText.includes('válid') ||
        currentText.includes('gültig');

      emailError.textContent = seemsInvalid
        ? dictionary.errors.emailInvalid
        : dictionary.errors.emailRequired;
    }
  };

  /**
   * Traduction principale du formulaire.
   */
  const translateTrackingPage = () => {
    const trackingContainer =
      document.querySelector('#yq-trackingBox') ||
      document.querySelector('#yq-tracking-form');

    if (!trackingContainer) {
      return;
    }

    setText('.yq-track-page-title', dictionary.title);
    setText('.yq-track-tab-order-num', dictionary.orderTab);
    setText('.yq-track-tab-tracking-num', dictionary.trackingTab);

    setInputTranslation(
      '#orderForm_order_no',
      dictionary.orderPlaceholder
    );

    setInputTranslation(
      '#orderForm_user_email',
      dictionary.emailPlaceholder
    );

    setInputTranslation(
      '#trackingForm_track_no',
      dictionary.trackingPlaceholder
    );

    document
      .querySelectorAll(
        '#orderForm button[type="submit"] span, ' +
        '#trackingForm button[type="submit"] span'
      )
      .forEach((buttonText) => {
        if (buttonText.textContent.trim() !== dictionary.trackButton) {
          buttonText.textContent = dictionary.trackButton;
        }
      });

    setText('#yq-tracking-loading p', dictionary.loading);

    /**
     * Libellé du sélecteur d’e-mail caché/visible.
     */
    document
      .querySelectorAll(
        '#orderForm .ant-select-selection-item'
      )
      .forEach((element) => {
        element.textContent = dictionary.emailPlaceholder;
        element.setAttribute(
          'title',
          dictionary.emailPlaceholder
        );
      });

    translateValidationErrors();
    translateTextNodes(trackingContainer);

    /**
     * Mise à jour de la langue HTML pour l’accessibilité.
     */
    document.documentElement.setAttribute('lang', language);
  };

  let translationScheduled = false;

  const scheduleTranslation = () => {
    if (translationScheduled) {
      return;
    }

    translationScheduled = true;

    window.requestAnimationFrame(() => {
      translationScheduled = false;
      translateTrackingPage();
    });
  };

  /**
   * Première traduction.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleTranslation,
      { once: true }
    );
  } else {
    scheduleTranslation();
  }

  /**
   * 17TRACK est une application React.
   * Le MutationObserver retraduit les éléments ajoutés après :
   * - le chargement ;
   * - un changement d’onglet ;
   * - une validation ;
   * - une recherche de colis.
   */
  const observer = new MutationObserver((mutations) => {
    const containsRelevantChange = mutations.some((mutation) => {
      if (mutation.type === 'characterData') {
        return Boolean(
          mutation.target.parentElement?.closest(
            '#yq-trackingBox, #yq-tracking-form'
          )
        );
      }

      return Array.from(mutation.addedNodes).some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return false;
        }

        return (
          node.matches?.(
            '#yq-trackingBox, #yq-tracking-form, ' +
            '.ant-form-item-explain-error'
          ) ||
          node.querySelector?.(
            '#yq-trackingBox, #yq-tracking-form, ' +
            '.ant-form-item-explain-error'
          )
        );
      });
    });

    if (containsRelevantChange) {
      scheduleTranslation();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  /**
   * Sécurité supplémentaire après l’hydratation React.
   */
  window.setTimeout(scheduleTranslation, 500);
  window.setTimeout(scheduleTranslation, 1500);
  window.setTimeout(scheduleTranslation, 3000);
})();